export default {
    namespaced: true,
    state: {
        currentUserID: null,
        user: [],
    },
    mutations: {
        SET_CURRENT_USER_ID(state, userID) {
            state.currentUserID = userID
        },
        SET_USER(state, user) {
            state.user = user
        },
    },
    actions: {
        setCurrentUserID({ commit }, userID) {
            commit('SET_CURRENT_USER_ID', userID)
        },
        setUser({ commit }, user) {
            commit('SET_USER', user)
        },
    },
    getters: {
        currentProfileUserID: (state) => {
            return state.currentUserID
        },
    },
}
